import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
});

async function initKeycloak(renderizarAppCallback: Function) {
  try {
    await keycloak.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      pkceMethod: 'S256'
    });
  } catch (error) {
    console.error('Erro na inicialização do Keycloak:', error);
  } finally {
    renderizarAppCallback();
  }
}

export const keycloakService = {
  initKeycloak,
  keycloak,
};
